import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Pricing'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 0C37.2857 0 48 10.7143 48 24C48 37.2857 37.2857 48 24 48C10.7143 48 0 37.2857 0 24C0 10.7143 10.7143 0 24 0Z"
          fill="#BEEBF6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8667 17.8667C21.659 17.8667 24.7333 16.3295 24.7333 14.4333C24.7333 12.5372 21.659 11 17.8667 11C14.0743 11 11 12.5372 11 14.4333C11 16.3295 14.0743 17.8667 17.8667 17.8667Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.7333 17.8667C24.7333 19.763 21.6594 21.3 17.8667 21.3C14.074 21.3 11 19.763 11 17.8667"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.7334 21.3V14.4333"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 14.4333V31.6C11 33.4964 14.074 35.0333 17.8667 35.0333C18.7314 35.0347 19.594 34.9492 20.4417 34.7781"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 28.1667C11 30.0631 14.074 31.6001 17.8667 31.6001C18.7314 31.6014 19.594 31.5159 20.4417 31.3449"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 24.7334C11 26.6297 14.074 28.1667 17.8667 28.1667C18.7314 28.1681 19.594 28.0826 20.4417 27.9115"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 21.3C11 23.1964 14.074 24.7334 17.8667 24.7334C18.7314 24.7347 19.594 24.6492 20.4417 24.4782"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.8833 29.8833C33.6756 29.8833 36.7499 28.3461 36.7499 26.4499C36.7499 24.5538 33.6756 23.0166 29.8833 23.0166C26.0909 23.0166 23.0166 24.5538 23.0166 26.4499C23.0166 28.3461 26.0909 29.8833 29.8833 29.8833Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.0166 26.45V33.3166C23.0166 35.213 26.0906 36.75 29.8833 36.75C33.676 36.75 36.7499 35.213 36.7499 33.3166V26.45"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.7499 29.8833C36.7499 31.7796 33.676 33.3166 29.8833 33.3166C26.0906 33.3166 23.0166 31.7796 23.0166 29.8833"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
